import { render, staticRenderFns } from "./PriceHandler.vue?vue&type=template&id=5de40800"
import script from "./PriceHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceHandler.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PriceHandler.vue?vue&type=style&index=0&id=5de40800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports